module.exports = __webpack_public_path__ + "img/image-03.6d6ee266.png";